import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders, HttpParams } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class ApiService {
  url = "https://themspacemcqs.herokuapp.com/mcqs/"
  httpHeaders = new HttpHeaders().set('Content-Type','application/json').set('Access-Control-Allow-Origin', '*');
  httpGetPost;
  constructor(private http : HttpClient) {

  }
  getPosts(question: string){
    return this.http.post(this.url+'getposts',{"question" : question},{headers: this.httpHeaders});
  }
  addPost(formData){
      return this.http.post(this.url+'addpost',formData,{headers: this.httpHeaders});
  }
  upvote(id){
    return this.http.post(this.url+'posts/upvote',{"id":id},{headers: this.httpHeaders});
  }
  downvote(id){
    return this.http.post(this.url+'posts/downvote',{"id":id},{headers: this.httpHeaders});
  }
}
